import CourseListByDepartment from './Request/Course_listCoursesByDepartment';
import graphql from './graphql';
import minutesToHour from '../Utils/MinutesToHours';
import arrayToString from '../Utils/ArrayToString';
import courseSetDepartmentType from './Request/Course_SetDepartmentType';

const mapCourseList = courses =>
  courses.map(course => [
    course.name || '',
    arrayToString(course?.Enterprise?.Terminals, 'name'),
    minutesToHour(course?.duration),
    course?.CourseCategory?.name || 'sin categoría',
    course?.Enterprise?.Terminals,
    course?.id,
    !!course.CourseType?.type,
    course?.isChecked,
  ]);

const mapCategories = coursesEnterprise => coursesEnterprise.map(category => category.name || '');

const mapTerminal = data => data.map(terminal => terminal.name);

const fetch = async departmentId => {
  const promises = [];
  promises.push(CourseListByDepartment(departmentId));
  promises.push(graphql('CourseCategory_list', 'name', 'query'));
  promises.push(graphql('Terminal_list', 'name', 'query'));

  const response = await Promise.all(promises);
  const courseByEnterprise = mapCourseList(response[0].EnterpriseCourses);
  const courseByDepartment = mapCourseList(response[0].DepartmentCourses);
  const categories = mapCategories(response[1].CourseCategory_list);
  const terminals = mapTerminal(response[2].Terminal_list);

  return { courseByEnterprise, courseByDepartment, categories, terminals };
};

export default fetch;

export const update = async (coursesData, departmentId) => courseSetDepartmentType(coursesData, departmentId);
